/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';


import Localized from '../../../../shared/components/Localized';
import styles from '../../../styles';

const Wrapper = styled.div`
  font-weight: 300;
  ${styles.fonts.headingMedium}
`;
const Success = () => (
  <Wrapper>
    <Localized modelKey='emailSentSuccess' modelAttribute='label' modelName='login' />
  </Wrapper>
);

export default Success;
